import {
  Breadcrumb,
  Row,
  Input,
  Col,
  Table,
  Modal,
} from "antd";
import "./AccountListPage.css";
import moment from "moment";
import { ACCOUNT_LIST_CONSTANT } from "../../constant/accountlist.constant";
import { BsSearch } from "react-icons/bs";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import { LockFilled, UnlockFilled } from '@ant-design/icons';
import CustomPagination from "../customPagination/CustomPagination";
import { useState, useEffect } from "react";
import { errorNotificationAlert } from "../notificationAlert/noticationAlert";
import { modalCustom } from "../modal/modalCustom";
import accoutListService from "../../service/accoutListService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_CONSTANT } from "../../constant/sidebar.constant";
import { ROUTER_CONSTANT } from "../../constant/router.constant";

const AccountListPage = () => {
  const dateToday = new Date();
  const [dataUserAccount, setDataUserAccount] = useState([]);
  const token = useSelector((state) => state.loginData.token);
  const [fetch, setFetch] = useState(false);
  const navigate = useNavigate();

  const [paginationData, setPaginationData] = useState(
    {
      current: 1,
      pageSize: 10,
    },
  );

  const [totalCountRow, setTotalCountRow] = useState(0);

  const [filterParams, setFilterParams] = useState(
    {
      SearchValue: "-",
      OrderByStatus: "N",
      OrderByUpdated: "N",
      OrderBy: "ASC"
    }
  );

  const columns = [
    {
      title: ACCOUNT_LIST_CONSTANT.TABLE_DATETIME_COLUMN,
      dataIndex: "updated_at",
      width: "10vw",
      align: "left",
      sorter: true,
      render: (datetime) => `${datetime ? moment.utc(datetime).format("DD/MM/YYYY - HH:mm:ss") : ""}`,
    },
    {
      title: ACCOUNT_LIST_CONSTANT.TABLE_FIRSTNAME_COLUMN,
      dataIndex: "first_name",
      width: "8vw",
      align: "left",
      render: (firstname) => `${firstname}`,
    },
    {
      title: ACCOUNT_LIST_CONSTANT.TABLE_LASTNAME_COLUMN,
      dataIndex: "last_name",
      width: "8vw",
      align: "left",
      render: (lastname) => `${lastname}`,
    },
    {
      title: ACCOUNT_LIST_CONSTANT.TALBE_PHONENUMBER_COLUMN,
      dataIndex: "phone",
      width: "8vw",
      align: "left",
      render: (phonenumber) => `${phonenumber}`,
    },
    {
      title: ACCOUNT_LIST_CONSTANT.TABLE_STATUS_COLUMN,
      dataIndex: "status",
      width: "5vw",
      align: "left",
      sorter: true,
      render: (status) => (
        <>
          {status === "A" ? activeSpan() : bannedSpan()}
        </>
      ),
    },
    {
      title: ACCOUNT_LIST_CONSTANT.TABLE_ACTION_COLUMN,
      width: "13vw",
      align: "left",
      render: (accountData) => (
        <Row justify="start">
          <Col span={3}>
            {accountData.status === "A" ?
              <UnlockFilled
                style={{ fontSize: "20px", cursor: "pointer", color: "rgba(66, 66, 66, 1)" }}
                onClick={() => handleNavigateDetail(accountData, ACCOUNT_LIST_CONSTANT.MODAL_DETAIL_TITLE_UNBANNED_ACCOUNT)}
              /> :
              <LockFilled
                onClick={() => handleUnbannedAccount(accountData)}
                style={{ fontSize: "20px", cursor: "pointer", color: "rgba(66, 66, 66, 1)" }} />
            }
          </Col>
          <Col span={3}>
            <IoIosArrowDroprightCircle
              onClick={() => handleNavigateDetail(accountData, ACCOUNT_LIST_CONSTANT.MODAL_DETAIL_TITLE_ACCOUNT)}
              style={{ fontSize: "20px", cursor: "pointer", color: "rgba(66, 66, 66, 1)" }} />
          </Col>
        </Row>
      ),
    },
  ];

  const onPagination = (currentIndex, currentSize) => {
    setPaginationData(
      {
        ...paginationData,
        current: currentIndex,
        pageSize: currentSize
      }
    );
  }

  const activeSpan = () => {
    return (
      <div className="status-position-style">
        <span className="active-span-style">
          Active
        </span>
      </div>
    )
  }

  const bannedSpan = () => {
    return (
      <div className="status-position-style">
        <span className="banned-span-style">
          Banned
        </span>
      </div>
    )
  }

  const okSuccessFunction = () => {
    // TODO: Success unbanned function
  }

  const handleUnbannedAccount = (dataAccount) => {
    Modal.confirm({
      title: ACCOUNT_LIST_CONSTANT.MODAL_TITLE_UNBANNED_ACCOUNT,
      content: ACCOUNT_LIST_CONSTANT.MODAL_CONTENT_UNBANNED_ACCOUNT,
      okText: ACCOUNT_LIST_CONSTANT.MODAL_OK_BUTTON_UNBANNED_ACCOUNT,
      cancelText: ACCOUNT_LIST_CONSTANT.MODAL_CANCEL_BUTTON_UNBANNED_ACCOUNT,
      centered: true,
      icon: null,
      onOk() {
        let params = {
          NextokenID: dataAccount.nextoken_user_id,
          Status: "A"
        }
        accoutListService.unbannedAccount(token, params).then((response) => {
          if (response.data.nexsoft.payload.status.success) {
            modalCustom(
              ACCOUNT_LIST_CONSTANT.MODAL_SUCCESS_TITLE_UNBANNED_ACCOUNT,
              ACCOUNT_LIST_CONSTANT.MODAL_SUCCESS_CONTENT_UNBANNED_ACCOUNT,
              ACCOUNT_LIST_CONSTANT.MODAL_SUCCESS_OK_BUTTON_UNBANNED_ACCOUNT,
              okSuccessFunction,
              "success"
            );
          } else {
            handleFailedUnbannedAccount();
          }
          setFetch(true);
        }).catch((error) => {
          handleFailedUnbannedAccount();
        });
      }
    });
  }

  const handleFailedUnbannedAccount = (error) => {
    modalCustom(
      ACCOUNT_LIST_CONSTANT.MODAL_FAILED_TITLE_UNBANNED_ACCOUNT,
      ACCOUNT_LIST_CONSTANT.MODAL_FAILED_CONTENT_UNBANNED_ACCOUNT,
      ACCOUNT_LIST_CONSTANT.MODAL_FAILED_OK_BUTTON_UNBANNED_ACCOUNT,
      okSuccessFunction,
      "failed"
    )
  }

  const handleNavigateDetail = (data, title) => {
    navigate(`${ROUTER_CONSTANT.HOME}${ROUTER_CONSTANT.ACCOUNT_LIST}/${data.nextoken_user_id}`, { state: data });
  }

  const handleChangeTable = (pagination, filters, sorter) => {
    let tempOrderByUpdated;
    let tempOrderBy;
    let tempOrderByStatus;

    if (sorter.field === "updated_at") {
      tempOrderByUpdated = "Y";
    } else {
      tempOrderByUpdated = "N";
    }

    if (sorter.field === "status") {
      tempOrderByStatus = "Y";
    } else {
      tempOrderByStatus = "N";
    }

    if (sorter.order === "descend") {
      tempOrderBy = "DESC";
    } else {
      tempOrderBy = "ASC";
    }

    if (!sorter.column) {
      tempOrderByUpdated = "N";
      tempOrderByStatus = "N";
      tempOrderBy = "ASC";
    }

    setFilterParams({
      ...filterParams,
      OrderByUpdated: tempOrderByUpdated,
      OrderBy: tempOrderBy,
      OrderByStatus: tempOrderByStatus
    });
  };

  const handleSearchValue = (event) => {
    let tempSearchValue = event.target.value || "-";
    setFilterParams({ ...filterParams, SearchValue: tempSearchValue });
    setPaginationData({ ...paginationData, current: 1 });
  }

  useEffect(() => {
    if (fetch) {
      setFetch(false);
    }

    const getListUserAccount = () => {
      let params = {
        PageSize: paginationData.pageSize,
        PageIndex: paginationData.current,
        SearchValue: filterParams.SearchValue,
        OrderByStatus: filterParams.OrderByStatus,
        OrderByUpdated: filterParams.OrderByUpdated,
        OrderBy: filterParams.OrderBy
      };

      accoutListService.getAllUserList(token, params)
        .then((response) => {
          if (response.data.nexsoft.payload.status.success) {
            setDataUserAccount(response.data.nexsoft.payload.data.content);
            setTotalCountRow(response.data.nexsoft.payload.data.meta)
          } else {
            setDataUserAccount(response.data.nexsoft.payload.data.content);
            setTotalCountRow(response.data.nexsoft.payload.data.meta)
            errorNotificationAlert(
              ACCOUNT_LIST_CONSTANT.NOTIFICATION_ERROR_TITLE,
              ACCOUNT_LIST_CONSTANT.NOTIFICATION_ERROR_CONTENT_GET_USERACCOUNTLIST,
              response.data.nexsoft.payload.status.message
            )
          }
        }).catch((error) => {
          errorNotificationAlert(
            ACCOUNT_LIST_CONSTANT.NOTIFICATION_ERROR_TITLE,
            ACCOUNT_LIST_CONSTANT.NOTIFICATION_ERROR_CONTENT_GET_USERACCOUNTLIST,
            ACCOUNT_LIST_CONSTANT.NOTIFICATION_ERROR_CONTENT_DETAIL_GET_USERACCOUNTLIST
          )
        });
    }

    getListUserAccount();
  }, [
    token,
    paginationData,
    filterParams,
    fetch
  ]);

  return (
    <>
      <Row>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>{SIDEBAR_CONSTANT.MENU_SETTING_LIST}</Breadcrumb.Item>
          <Breadcrumb.Item>{ACCOUNT_LIST_CONSTANT.MENU_USER_ACCOUNT_LIST}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row>
        <div className="accountlist-title">
          {ACCOUNT_LIST_CONSTANT.MENU_USER_ACCOUNT_LIST}
        </div>
      </Row>

      <Row>
        <span className="accountlist-datetime-span">
          {moment(dateToday).format("DD MMMM YYYY")}
        </span>
      </Row>
      <br />

      <Row>
        <Col span={8}>
          <Input onChange={(e) => handleSearchValue(e)} placeholder={ACCOUNT_LIST_CONSTANT.PLACEHOLDER_SEARCH} suffix={<BsSearch />} />
        </Col>
      </Row>

      <br />

      <Row>
        <div className="table-round-style">
          <Table
            columns={columns}
            dataSource={dataUserAccount}
            pagination={false}
            scroll={{ x: 900 }}
            rowKey="nextoken_user_id"
            size="small"
            onChange={handleChangeTable}
          >
          </Table>
          <CustomPagination pagination={paginationData} OnPagination={onPagination} totalCountRow={totalCountRow} />
        </div>
      </Row>
      <br /><br />
    </>
  )
}

export default AccountListPage;